import React from "react";
import InfoSection from "./InfoSection";
import EditableInfoRow from "./EditableInfoRow";

const IS_REGISTERED_OPTIONS = [
    { id: 1, name: "Yes" },
    { id: 0, name: "No" }
];

const SpecificDetails = ({ data, isEditing, isLoading, onEdit, onSave, onCancel, onChange }) => {
    const registrationDetails = data || {};

    return (
        <InfoSection
            title="Registration Details"
            icon="solar:document-medicine-bold"
            isEditing={isEditing}
            isLoading={isLoading}
            onEdit={onEdit}
            onSave={onSave}
            onCancel={onCancel}
        >
            <div className="row">
                <EditableInfoRow
                    label="Is Registered"
                    value={registrationDetails.isRegistered}
                    displayValue={Number(registrationDetails.isRegistered) === 1 ? "Yes" : Number(registrationDetails.isRegistered) === 0 ? "No" : "-"}
                    icon="solar:verified-check-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="isRegistered"
                    onChange={onChange}
                    type="select"
                    options={IS_REGISTERED_OPTIONS}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select option"
                />
                <EditableInfoRow
                    label="Registration Number"
                    value={registrationDetails.registrationData}
                    icon="solar:document-text-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="registrationData"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Registration Authority"
                    value={registrationDetails.registrationAuthority}
                    icon="solar:buildings-3-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="registrationAuthority"
                    onChange={onChange}
                />
                <EditableInfoRow
                    label="Date of Registration"
                    value={registrationDetails.dateOfRegistration}
                    icon="solar:calendar-bold-duotone"
                    colSize="col-md-6"
                    isEditing={isEditing}
                    fieldKey="dateOfRegistration"
                    onChange={onChange}
                    type="date"
                />
            </div>
        </InfoSection>
    );
};

export default SpecificDetails;
